import { Component, Input, OnInit } from "@angular/core";
import { FinishModel } from "./../../../../../src/app/finish/model/finish.model";
import { MonitoringService } from "../../services/monitoring.service";

@Component({
    selector: "mob-card-small",
    templateUrl: "./card-small.component.html",
    styleUrls: ["./card-small.component.scss"],
})
export class CardSmallComponent implements OnInit {
    @Input() VO: FinishModel;
    public localImagePlace = "./assets/img/finish/open_finance.svg"
    public name: string;

    constructor(private monitoringService: MonitoringService){}

    private sanitizeOption(option: string){
        const formatedOption = option.toLowerCase().trim()
        if(formatedOption.indexOf("finance") !== -1) return "open-finance"
        if(formatedOption.indexOf("crédito") !== -1) return "open-finance"
        if(formatedOption.indexOf("pj") !== -1) return "abra-uma-conta-pj"
        if(formatedOption.indexOf("benefícios") !== -1) return "beneficios"
    }

    public sendMonitoringData(option: string){
        const sanitizedOption = this.sanitizeOption(option)
        this.monitoringService.click(`card:${sanitizedOption}`)
    }
    ngOnInit() {
        if(this.VO?.cardFeedBackList){
            this.VO?.cardFeedBackList.map((item) => {
                if (item.icon == 'open-finance') item.icon = null
            });
        }
    }

    titleButton(title){
        switch (title) {
            case '_onboardinglink_componente_finish_card_1':
                return 'Cadastrar'
            case '_onboardinglink_componente_finish_card_2':
                return 'Abrir conta'
            case '_onboardinglink_componente_finish_card_3':
                return 'Saiba mais'
            default:
                return ''
        }
    }
}

